module.exports = __webpack_public_path__ + "static/img/policy-manual-wizard.a799c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots/policy-manual-wizard.png
// module id = emVL
// module chunks = 0